<div class="row animated fadeIn">
  <div class="col-md-12">
    <div class="row justify-content-between align-items-center mb-2 zIndexUp">
      <h4 class="col-xl-auto col-lg-auto col-md-6 col-sm-6 mb-lg-0 mb-sm-2 mb-md-2 mb-2">Contact</h4>
      <ul
        class="list-unstyled action-tool-bar col-xl-auto col-lg-auto col-md-10 col-sm-12 mb-0 d-flex align-items-center flex-wrap">
        <li *ngIf="permission.Contact_Filter==1 || roleid==1"> <a href="javascript:void(0);"
            class="btn btn-sm btn-light-info bg-info border-info" (click)="openClosefun()"><span
              class="mdi mdi-filter"></span>
            Filter</a></li>
        <li *ngIf="permission.Contact_Export==1 || roleid==1"> <a href="javascript:void(0);"
            class="btn btn-sm btn-light-info bg-primary border-primary" (click)="ExportOpenModal(exportConfirm)"><span
              class="mdi mdi-export"></span>
            Export</a></li>
        <li *ngIf="permission.Contact_Import==1 || roleid==1"> <a href="javascript:void(0);"
            class="btn btn-sm btn-light-info bg-danger border-danger" (click)="addDocument.show()"><span
              class="mdi mdi-import"></span>
            Import</a></li>
        <li *ngIf="permission.Contact_Add==1 || roleid==1"> <a href="javascript:void(0);"
            routerLink="/contacts/addcontact" class="btn btn-sm btn-light-info"><span class="mdi mdi-plus"></span>
            Add Contact</a></li>
      </ul>
    </div>

    <div class="card mt-3" *ngIf="isCollapsed">
      <div class="card-body">
        <form [formGroup]="registerForm">
          <div class="form-row">
            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="d-flex align-items-center">Companies</label>
              <angular2-multiselect [settings]="dropdowncompany" [data]="CompanyList" [(ngModel)]="selectedCompany"
                formControlName="Company" (onSelect)="oncompanySelect($event)" (onDeSelect)="oncompanySelect($event)"
                (onSelectAll)="oncompanySelect($event)" (onDeSelectAll)="oncompanySelect($event)" fixSearchBug>
              </angular2-multiselect>
            </div>
            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="d-flex align-items-center">Designation</label>
              <angular2-multiselect [settings]="dropdownDesignation" [data]="designationList"
                formControlName="Designation" [ngvalue]="designationList" [(ngModel)]="selectedDesignation"
                (onSelect)="onDesignationSelect($event)" (onDeSelect)="onDesignationSelect($event)"
                (onSelectAll)="onDesignationSelect($event)" (onDeSelectAll)="onDesignationSelect($event)" fixSearchBug>
              </angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="">Country</label>
              <angular2-multiselect [settings]="dropdownCountry" [data]="CountryList" formControlName="Country"
                [(ngModel)]="selectedCountry" (onSelect)="onCountrySelect($event)"
                (onDeSelect)="onCountrySelect($event)" (onSelectAll)="onCountrySelect($event)"
                (onDeSelectAll)="onCountrySelect($event)" fixSearchBug>
              </angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="d-flex justify-content-between align-items-center">State
              </label>
              <angular2-multiselect [settings]="dropdownState" [data]="stateList" [(ngModel)]="selectedState"
                formControlName="State" (onSelect)="onStateSelect($event)" (onDeSelect)="onStateSelect($event)"
                (onSelectAll)="onStateSelect($event)" (onDeSelectAll)="onStateSelect($event)"
                fixSearchBug></angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="d-flex justify-content-between align-items-center">City
              </label>
              <angular2-multiselect [settings]="dropdownCity" [data]="cityList" [(ngModel)]="selectedCity"
                formControlName="City" (onSelect)="onCitySelect($event)" (onDeSelect)="onCitySelect($event)"
                (onSelectAll)="onCitySelect($event)" (onDeSelectAll)="onCitySelect($event)"
                fixSearchBug></angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="d-flex align-items-center">Contact Owner</label>
              <angular2-multiselect formControlName="ContactOwner" [settings]="dropdownower" [data]="ownerList"
                [(ngModel)]="selectedowner" [ngClass]="{ 'is-invalid': submitted && f.ContactOwner.errors }"
                (onSelect)="onwnerSelect($event)" (onDeSelect)="onwnerSelect($event)"
                (onSelectAll)="onwnerSelect($event)" (onDeSelectAll)="onwnerSelect($event)" fixSearchBug>
              </angular2-multiselect>
            </div>
          </div>

          <div class="form-row mt-2">

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="d-flex align-items-center">Nationality</label>
              <angular2-multiselect [settings]="dropdownNationality" [data]="CountryList"
                [(ngModel)]="selectedNationality" formControlName="Nationality" (onSelect)="onNationalitySelect($event)"
                (onDeSelect)="onNationalitySelect($event)" (onSelectAll)="onNationalitySelect($event)"
                (onDeSelectAll)="onNationalitySelect($event)" fixSearchBug></angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="d-flex align-items-center">Religion</label>
              <angular2-multiselect [settings]="dropdownReligion" [data]="ReligionList" [(ngModel)]="selectedReligion"
                formControlName="Religion" (onSelect)="onReligionSelect($event)" (onDeSelect)="onReligionSelect($event)"
                (onSelectAll)="onReligionSelect($event)" (onDeSelectAll)="onReligionSelect($event)"
                fixSearchBug></angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="d-flex align-items-center">Language</label>
              <angular2-multiselect [settings]="dropdownLanguage" [data]="LanguageList" [(ngModel)]="selectedLanguage"
                formControlName="Language" (onSelect)="onLanguageSelect($event)" (onDeSelect)="onLanguageSelect($event)"
                (onSelectAll)="onLanguageSelect($event)" (onDeSelectAll)="onLanguageSelect($event)"
                fixSearchBug></angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="d-flex align-items-center">Pro Reservation</label>
              <angular2-multiselect [settings]="dropdownProReservation" [data]="ReservationList"
                [(ngModel)]="selectedReservation" formControlName="ProReservation"
                (onSelect)="onReservationSelect($event)" (onDeSelect)="onReservationSelect($event)"
                (onSelectAll)="onReservationSelect($event)" (onDeSelectAll)="onReservationSelect($event)" fixSearchBug>
              </angular2-multiselect>
            </div>

            <div class="col-xl-2 col-lg-4 col-md-6 mb-2">
              <label for="" class="d-flex align-items-center">Status
              </label>
              <angular2-multiselect [settings]="dropdownSettings5" [data]="dropdownList5" [(ngModel)]="selectedItems5"
                formControlName="Status" (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)"
                (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)"
                fixSearchBug></angular2-multiselect>
            </div>

            <div class="form-group mt-2 mt-md-4 pt-1 pt-md-2 col-auto" *ngIf="roleid==1">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" id="a" class="custom-control-input" formControlName="VVIP">
                <label for="a" class="custom-control-label">VVIP</label>
              </div>
            </div>

            <div class="col-xl-2 date-filter-field-3 col-lg-4 col-md-6 mb-3 mb-md-2">
              <label for="" class="d-flex align-items-center">Created Date</label>
              <div class="input-group">
                <div class="w-100">
                  <input class="bg-calender-icon form-control" type="text" [showDropdowns]="true" ngxDaterangepickerMd
                    [(ngModel)]="date_range" [showCustomRangeLabel]="true" [alwaysShowCalendars]="true"
                    [ranges]="ranges" [settings]="dropdownSettings" [showClearButton]="true" placeholder="Select Range"
                    [ngModelOptions]="{standalone: true}" />
                  <sapn class="position-absolute" style="top: 50%; right: 7%; transform: translate(-50%, -50%);">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x"
                      viewBox="0 0 16 16" (click)="clearEndDate()">
                      <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                    </svg>
                  </sapn>
                </div>
              </div>
            </div>

            <div class="col-auto mb-2 mb-md-0">
              <label for="" class="d-none d-md-block">&nbsp;</label>
              <a href="javascript:void(0);" class="btn btn-outline-info d-flex align-items-center btn-new-light-info"
                title="Apply" (click)="onSubmit()">
                <i class="mdi mdi-checkbox-marked-outline mdi-18px"></i> Apply</a>
            </div>
            <div class="col-auto mb-2 mb-md-0">
              <label for="" class="d-none d-md-block">&nbsp;</label>
              <a href="javascript:void(0);" class="btn btn-outline-info d-flex align-items-center btn-new-light-info"
                title="Reset" (click)="resetData()">
                <i class="mdi mdi-reload mdi-18px"></i></a>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <mat-form-field class="example-full-width pb-0 w-100 form-control-design1" appearance="fill"
            style="width: 250px !important; float: right;">
            <input #inputField matInput class="text-limit  pos-search" [(ngModel)]="searchword" placeholder="Search"
              (keyup.enter)="applyFilter()" /><span class="mdi mdi-magnify mdi-2x cursor-pointer " title="Search"
              style="position: absolute;right: 0;font-size: 20px;color: #999;top: 0;" (click)="applyFilter();"></span>
            <span class="position-absolute" style="top: 50%; right: 7%; transform: translate(-50%, -50%);"
              title="Clear">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x"
                viewBox="0 0 16 16" (click)="clearUserData(); applyFilter()" (clearEvent)="searchword=''"
                *ngIf="searchword">
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </span>
          </mat-form-field>
          <table class="table" mat-table matSorts [dataSource]="dataSource" matSort [matSortActive]="'name'"
            [matSortDisableClear]="true" [matSortDirection]="'asc'" [multiTemplateDataRows]="true"
            (matSortChange)="onSortData($event)" aria-hidden="true">
            <!-- Name Column -->
            <ng-container matColumnDef="ContactName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact Name<img src="assets/images/sort_both.png"
                  *ngIf="columnsort!='ContactName'" alt=""><img src="assets/images/sort_up.png" alt=""
                  *ngIf="upicon && !downicon && columnsort =='ContactName'"><img src="assets/images/sort_down.png"
                  *ngIf="downicon && !upicon && columnsort =='ContactName'" alt=""></th>
              <td mat-cell *matCellDef="let element"><a *ngIf="permission.Contact_View==1 || roleid==1"
                  href="javascript:void(0);" (click)="view(element.ContactId)">{{element['ContactName']}}</a></td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="CompanyName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Company Name<img src="assets/images/sort_both.png"
                  *ngIf="columnsort!='CompanyName'" alt=""><img src="assets/images/sort_up.png" alt=""
                  *ngIf="upicon && !downicon && columnsort =='CompanyName'"><img src="assets/images/sort_down.png"
                  *ngIf="downicon && !upicon && columnsort =='CompanyName'" alt=""></th>
              <td mat-cell *matCellDef="let element">{{element['CompanyName']}}</td>
            </ng-container>

            <ng-container matColumnDef="Designation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Designation<img src="assets/images/sort_both.png"
                  *ngIf="columnsort!='Designation'" alt=""><img src="assets/images/sort_up.png" alt=""
                  *ngIf="upicon && !downicon && columnsort =='Designation'"><img src="assets/images/sort_down.png"
                  *ngIf="downicon && !upicon && columnsort =='Designation'" alt=""></th>
              <td mat-cell *matCellDef="let element"> {{element['DesignationName']}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="City.Country">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>City & Country<img src="assets/images/sort_both.png"
                  *ngIf="columnsort!='City.Country'" alt=""><img src="assets/images/sort_up.png" alt=""
                  *ngIf="upicon && !downicon && columnsort =='City.Country'" alt=""><img
                  src="assets/images/sort_down.png" *ngIf="downicon && !upicon && columnsort =='City.Country'" alt="">
              </th>
              <td mat-cell *matCellDef="let element">{{element['CityName']}}, {{element['CountryName']}}</td>
            </ng-container>

            <ng-container matColumnDef="Email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Email<img src="assets/images/sort_both.png"
                  *ngIf="columnsort!='Email'" alt=""><img src="assets/images/sort_up.png" alt=""
                  *ngIf="upicon && !downicon && columnsort =='Email'" alt=""><img src="assets/images/sort_down.png"
                  *ngIf="downicon && !upicon && columnsort =='Email'" alt=""></th>
              <td mat-cell *matCellDef="let element"><a href="mailto:{{element['Email']}}">{{element['Email']}}</a></td>
            </ng-container>

            <ng-container matColumnDef="Mobile">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile<img src="assets/images/sort_both.png"
                  *ngIf="columnsort!='Mobile'" alt=""><img src="assets/images/sort_up.png" alt=""
                  *ngIf="upicon && !downicon && columnsort =='Mobile'"><img src="assets/images/sort_down.png"
                  *ngIf="downicon && !upicon && columnsort =='Mobile'" alt=""></th>
              <td mat-cell *matCellDef="let element"> {{element['Mobile']}} </td>
            </ng-container>

            <ng-container matColumnDef="ContactOwner">
              <th style="min-width: 130px" mat-header-cell *matHeaderCellDef mat-sort-header>Contact Owner<img
                  src="assets/images/sort_both.png" alt="" *ngIf="columnsort!='ContactOwner'"><img alt=""
                  src="assets/images/sort_up.png" *ngIf="upicon && !downicon && columnsort =='ContactOwner'"><img
                  src="assets/images/sort_down.png" alt="" *ngIf="downicon && !upicon && columnsort =='ContactOwner'">
              </th>
              <td mat-cell *matCellDef="let element"> {{element['UserName']}} </td>
            </ng-container>

            <ng-container matColumnDef="Status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status<img src="assets/images/sort_both.png"
                  *ngIf="columnsort!='Status'" alt=""><img src="assets/images/sort_up.png" alt=""
                  *ngIf="upicon && !downicon && columnsort =='Status'"><img src="assets/images/sort_down.png"
                  *ngIf="downicon && !upicon && columnsort =='Status'" alt=""></th>
              <td mat-cell *matCellDef="let element">
                <span *ngIf="element.StatusName=='Active'" class="badge badge-info text-dark"
                  title="{{element['StatusRemark']}}">
                  {{element['StatusName']}}</span>
                <span *ngIf="element.StatusName=='Inactive'" class="badge badge-danger text-dark"
                  title="{{element['StatusRemark']}}">{{element['StatusName']}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef><span class="mdi mdi-settings"></span></th>
              <td mat-cell *matCellDef="let element">
                <div ngbDropdown class="d-block list-dropdown-box">
                  <a href="javascript:void(0);" class="text-center d-block" id="dropdownBasic1" ngbDropdownToggle> <i
                      class="mdi mdi-dots-vertical mdi-24"></i></a>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
                    <div class="d-block">
                      <a *ngIf="element.StatusName=='Inactive'" class="" placement="bottom" href="javascript:void(0);"
                        title="Active" (click)="openStatusModel(statusConfirm,element.ContactId,'1',element)"><button
                          ngbDropdownItem><i class="mdi mdi-eye-off"></i>Status</button></a>
                      <a *ngIf="element.StatusName=='Active'" class="" placement="bottom" href="javascript:void(0);"
                        title="Inactive" (click)="openStatusModel(statusConfirm,element.ContactId,'2',element)"><button
                          ngbDropdownItem><i class="mdi mdi-eye"></i>
                          Status</button></a>
                      <div *ngIf="permission.Contact_Edit==1 || roleid==1">
                        <a href="javascript:void(0);" class="" placement="bottom"
                          (click)="edit(element.ContactId)"><button ngbDropdownItem><i class="mdi mdi-pencil"></i>
                            Edit</button></a>
                      </div>
                      <div
                        *ngIf="(permission.Contact_Delete==1 || roleid==1) && (element.Status!=3 && element.StatusName!='Delete')">
                        <a href="javascript:void(0);" class="" placement="bottom"
                          (click)="deleteOpenModal(deleteConfirm,element,'3')"><button ngbDropdownItem><i
                              class="mdi mdi-delete"></i>
                            Delete</button></a>
                      </div>
                      <div
                        *ngIf="(permission.Contact_Restore==1 || roleid==1) && (element.Status==3 && element.StatusName=='Delete')">
                        <a href="javascript:void(0);" class="" placement="bottom"
                          (click)="restoreOpenModal(restoreConfirm,element)">
                          <button ngbDropdownItem><i class="mdi mdi-backup-restore"></i>
                            Restore</button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr class="odd" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <div *ngIf="TotalRecord == 0" class="text-center">
            No Record found.
          </div>

          <div *ngIf="TotalRecord > 0">
            <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50, 100]" [length]="totalSize" showFirstLastButtons
              aria-label="Select page of periodic elements" [pageIndex]="currentPage" (page)="handlePage($event)"
              [pageSize]="pageSize">
            </mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #statusConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Contact Status Change</strong></h4>
    <button type="button" class="close" (click)="decline(); modalRef.hide(); clear()" data-dismiss="modal"
      aria-label="Close"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong>Contact_Name - {{name}}</strong></p>
    <p class="text-left mb-2"><strong>Status - {{ConStatus}}</strong></p>
    <form [formGroup]="StatusForm">
      <p class="text-left mb-2"><strong>Remark :</strong></p>
      <textarea class="form-control" maxlength="200" formControlName="Remark" (input)="NameSpaceNotAllowed($event)"
        [ngClass]="{ 'is-invalid': submitted1 && StatusForm.get('Remark').errors }"></textarea>
      <div
        *ngIf="StatusForm.get('Remark').invalid && StatusForm.get('Remark').errors && (StatusForm.get('Remark').dirty || StatusForm.get('Remark').touched) || submitted1">
        <small class="text-danger" *ngIf="StatusForm.get('Remark').hasError('required')">
          Remark is Required
        </small>
      </div>
    </form><br>
    <p class="text-left mb-2"> Are you sure you want to change the status ?</p>
  </div>

  <div class="modal-footer">
    <button href="javascript:void(0);" type="submit" class="btn btn-info btn-sm" (click)="makeActiveInactive()"
      [disabled]="delNameDel">Change Status</button>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline(); modalRef.hide(); clear()">Cancel</button>
  </div>
</ng-template>

<!--Delete modal-->
<ng-template #deleteConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Contact Delete</strong></h4>
    <button type="button" class="close" (click)="decline(); modalRef.hide();" data-dismiss="modal"
      aria-label="Close"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong>Contact_Name - {{file}}</strong></p>
    <p class="text-left mb-2">Do you want to delete this user ?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="deletecontact(); modalRef.hide();"
      [disabled]="delNameDel">Delete</button>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<!--Restore modal-->
<ng-template #restoreConfirm>
  <div class="modal-header">
    <h4 class="modal-title text-dark"><strong>Contact Restore</strong></h4>
    <button type="button" class="close" (click)="decline(); modalRef.hide();" data-dismiss="modal"
      aria-label="Close"><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <p class="text-left mb-2"><strong>Contact_Name - {{file}}</strong></p>
    <p class="text-left mb-2">Do you want to restore this user ?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="restorecontact(); modalRef.hide();"
      [disabled]="delNameDel">Restore</button>
    <button type="button" class="btn btn-sm btn btn-secondary ml-2"
      (click)="decline(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<ng-template #exportConfirm>
  <div class="modal-body text-center">
    <p>Do you want to export?</p>
    <button type="button" class="btn btn-info btn-sm" (click)="exportcontact(); modalRef.hide();"
      [disabled]="exportName">Confirm</button>
    <button type="button" class="btn btn-light btn-sm ml-2" (click)="decline(); modalRef.hide();">Cancel</button>
  </div>
</ng-template>

<div class="modal fade" bsModal #addDocument="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Contact Import</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="addDocument.hide();rtnView();">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form action="">
          <div class="form-row animated fadeIn">
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Upload Document</label>
                <input type="file" id="" class="form-control" (change)="onChange($event)" accept=".xlsx" #inputFile>
              </div>
              <p class="text-info mb-0 mt-1"><a href={{sampleContactExl}} download>Sample File</a></p>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button href="javascript:void(0);" class="btn btn-sm btn btn-info" (click)="import();">Import</button>
        <input #showimport (click)="ImportResult.show()" type="hidden">
        <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2"
          (click)="addDocument.hide();rtnView();">Close</a>
      </div>
    </div>
  </div>
</div>
<!--Start Company Import Result modal-->

<div class="modal fade" bsModal #ImportResult="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md modal-dialog-centered">
    <div class="modal-content animated zoomIn">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">Contact Import Result</h4>
      </div>
      <div class="modal-body">
        <form action="">
          <div class="form-row animated fadeIn">
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Total Records:
                  <span class="font-weight-bold"> {{Totalrec}} </span>
                </label>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Successful Records:
                  <span class="font-weight-bold"> {{valid}}</span>
                </label>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <div class="form-group mb-0">
                <label>Invalid Records:
                  <span class="font-weight-bold d-inline-block" (click)="openClosefun()" style="cursor:pointer">
                    {{invalid}}</span>
                </label>
              </div>
            </div>
          </div>

          <div class="form-row animated fadeIn" *ngIf="isCollapsed">
            <div class="col-lg-12 col-md-12">
              <div class="table-responsive" style="max-height: 300px;">
                <table class="table mb-0" aria-hidden="true">
                  <tbody>
                    <tr *ngFor="let item of dataarray; let i = index">
                      <td>Row {{item.Row}}</td>
                      <td>{{item.Error}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <a href="javascript:void(0);" class="btn btn-sm btn btn-info" (click)="ImportResult.hide();rtnView();">OK</a>
      </div>

    </div>
  </div>
</div>
<!-- End Company Import Result modal-->

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>